import React from 'react';
import UserApp from './components/UserApp';

const UserAppPage: React.FC = () => {
    return <UserApp />;
};

export default UserAppPage;
